<template>
  <div class="group-page">
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="group-page-index">
      <div class="page-header">
        <div class="header-row">
          <svg width="20" height="20" viewBox="0 0 28 28" fill="none" class="header-icon-sm">
            <rect x="2" y="6" width="10" height="10" rx="2.5" stroke="#2dd4bf" stroke-width="1.8" opacity="0.4" />
            <rect x="16" y="6" width="10" height="10" rx="2.5" stroke="#2dd4bf" stroke-width="1.8" opacity="0.6" />
            <rect x="9" y="14" width="10" height="10" rx="2.5" stroke="#2dd4bf" stroke-width="1.8" />
            <circle cx="14" cy="19" r="1.5" fill="#2dd4bf" opacity="0.6" />
          </svg>
          <h1 class="page-title">分组管理</h1>
        </div>
      </div>

      <div v-for="row in tableData" v-bind:key="row" style="padding: 0 16px 12px 16px;">
        <div class="group-card" @click="open_group_action(row, 1)">
          <div class="group-card-header">
            <div class="group-dot"></div>
            <span class="group-name">{{ row.group }}</span>
            <span class="group-count">{{ row.devnum }} 台设备</span>
          </div>

          <div v-if="row.nextgplist && row.nextgplist.length > 0" class="group-sub-list">
            <div v-for="next in row.nextgplist" v-bind:key="next" class="group-sub-item"
              @click.stop="open_group_action(next, 0)">
              <span class="sub-dot"></span>
              <span class="sub-name">{{ next.group }}</span>
              <span class="sub-count">{{ next.devnum }} 台</span>
            </div>
          </div>

          <div v-else class="group-empty">暂无下级分组</div>
        </div>
      </div>

      <div v-if="tableData.length === 0" class="empty-state">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <rect x="10" y="14" width="40" height="32" rx="6" stroke="#cbd5e1" stroke-width="2" opacity="0.5" />
          <circle cx="30" cy="30" r="6" stroke="#cbd5e1" stroke-width="2" opacity="0.5" />
          <line x1="22" y1="14" x2="22" y2="46" stroke="#cbd5e1" stroke-width="1.5" opacity="0.3" />
          <line x1="38" y1="14" x2="38" y2="46" stroke="#cbd5e1" stroke-width="1.5" opacity="0.3" />
        </svg>
        <p class="empty-text">暂无分组，点击下方按钮添加</p>
      </div>

      <div class="bottom-action">
        <button class="submit-btn" @click="addonegroupclick('')">
          添加分组
        </button>
      </div>
    </van-pull-refresh>

    <van-tabbar route class="crystal-tabbar">
      <van-tabbar-item icon="home-o" to="/devlist" replace>主页</van-tabbar-item>
      <van-tabbar-item icon="setting-o" to="/group" replace>分组管理</van-tabbar-item>
      <van-tabbar-item icon="friends-o" to="/user" replace>账户</van-tabbar-item>
    </van-tabbar>

    <van-action-sheet v-model="sheetshow" :actions="sheetactions" cancel-text="取消" close-on-click-action
      @cancel="sheetonCancel" @select="sheetonSelect" :description="g_buf.group" />

    <van-dialog v-model="addgroupdialog" title="添加分组" show-cancel-button :beforeClose="addgroupClose"
      class-name="crystal-dialog">
      <div class="dialog-body">
        <label class="dialog-label">分组名称</label>
        <div class="dialog-input-wrap">
          <van-field v-model="gname" placeholder="输入分组名称" input-class="dialog-field" />
        </div>
      </div>
    </van-dialog>

    <van-dialog v-model="changegroupdialog" title="修改分组名称" show-cancel-button :beforeClose="changegroupClose"
      class-name="crystal-dialog">
      <div class="dialog-body">
        <label class="dialog-label">分组名称</label>
        <div class="dialog-input-wrap">
          <van-field v-model="gname" placeholder="输入分组名称" input-class="dialog-field" />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'GroupPage',
  data() {
    return {
      gid: '',
      gfid: '',
      gname: '',
      addgroupdialog: false,
      changegroupdialog: false,
      tableData: [],
      isLoading: false,
      sheetshow: false,
      is_login: false,
      isWechatMiniProgram: false,
      sheetactions: [{
        name: '修改分组名称'
      }, {
        name: '删除分组',
        color: '#ee0a24'
      }],
      g_buf: "",
    };
  },
  mounted() {
    this.isWechatMiniProgram = this.$store.state.is_xcx;
    this.group_list();
  },
  methods: {
    toggleGroup(header) {
      header.classList.toggle('active');
    },
    open_group_action(g, j) {
      this.g_buf = g;
      this.sheetshow = true;
      if (j)
        this.sheetactions = [{
          name: '添加下级分组'
        }, {
          name: '修改分组名称'
        }, {
          name: '删除分组',
          color: '#ee0a24'
        }]
      else
        this.sheetactions = [{
          name: '修改分组名称'
        }, {
          name: '删除分组',
          color: '#ee0a24'
        }]
    },
    sheetonSelect(item) {
      this.sheetshow = false;
      if (item.name == '添加下级分组') {
        this.addgroupclick(this.g_buf.gid)
      } else if (item.name == '修改分组名称') {
        this.changegroupclick(this.g_buf.gid)
      } else if (item.name == '删除分组') {
        this.deleteClick(this.g_buf.group, this.g_buf.gid)
      }
    },
    sheetonCancel() {
      this.sheetshow = false;
    },
    addgroupClose(action, done) {
      if (action === 'confirm') {
        done(false);
        this.addgroupdialog = false;
        this.addgroup(this.gname, this.gfid);
      } else if (action === 'cancel') {
        done();
      }
    },
    changegroupClose(action, done) {
      if (action === 'confirm') {
        done(false);
        this.changegroupdialog = false;
        this.group_change(this.gid, this.gname);
      } else if (action === 'cancel') {
        done();
      }
    },
    onReflash() {
      this.group_list();
      this.isLoading = false;
    },
    group_list() {
      const qs = require('qs');
      this.$axios.post('/api/group/list', qs.stringify({
        '1': 1
      }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.tableData = response.data.grouplist;
            this.is_login = true;
            console.log(this.tableData);
          } else if (response.data.error_code === 301) {
            this.is_login = false;
            if (this.isWechatMiniProgram === false) {
              this.$router.push({
                path: '/login',
                name: 'login'
              })
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteClick(group, gid) {
      this.$dialog.confirm({
        title: '删除分组',
        message: '确认要删除"' + group + '"分组?'
      }).then(() => {
        this.group_delete(gid);
      }).catch(() => { });
    },
    group_delete(gid) {
      const qs = require('qs');
      this.$axios.post('/api/group/delete', qs.stringify({
        'gid': gid
      }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({
              type: 'success',
              message: '删除分组成功'
            });
            this.group_list();
          } else if (response.data.error_code === 301) {
            /*
            this.$router.push({
              path: '/login',
              name: 'login'
            });
            */
          } else {
            this.$notify({
              type: 'danger',
              message: '删除分组失败！'
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: 'danger',
            message: '删除分组失败！'
          });
        });
    },
    addgroupclick(gfid) {
      this.gfid = gfid;
      this.gname = '';
      this.addgroupdialog = true;
    },
    addonegroupclick(gfid) {
      if (this.is_login === false) {
        /*
        this.$router.push({
          path: '/login',
          name: 'login'
        })
          */
        return;
      }
      this.gfid = gfid;
      this.gname = '';
      this.addgroupdialog = true;
    },
    addgroup(gname, gfid) {
      const qs = require('qs');
      this.$axios.post('/api/group/add', qs.stringify({
        'group': gname,
        'gfid': gfid
      }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({
              type: 'success',
              message: '添加分组成功'
            });
            this.group_list();
          } else if (response.data.error_code === 301) {
            /*
            this.$router.push({
              path: '/login',
              name: 'login'
            });
            */
          } else {
            this.$notify({
              type: 'danger',
              message: '添加分组失败！'
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            type: 'danger',
            message: '添加分组失败！'
          });
        });
    },
    changegroupclick(gid) {
      this.gid = gid;
      this.gname = '';
      this.changegroupdialog = true;
    },
    group_change(gid, new_group) {
      const qs = require('qs');
      this.$axios.post('/api/group/change', qs.stringify({
        'gid': gid,
        'new_group': new_group
      }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({
              type: 'success',
              message: '修改分组成功'
            });
            this.group_list();
          } else if (response.data.error_code === 301) {
            /*
            this.$router.push({ path: '/login', name: 'login' })
            */
          } else {
            this.$notify({
              type: 'danger',
              message: '添加分组失败！'
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.van-dialog.crystal-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.crystal-dialog .van-dialog__header {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
  padding-top: 24px;
  font-family: inherit;
}

.crystal-dialog .van-dialog__confirm,
.crystal-dialog .van-dialog__confirm:active {
  color: #2dd4bf !important;
}

.crystal-dialog .van-dialog__cancel {
  color: #94a3b8;
}

.crystal-dialog .van-hairline--top {
  border-color: #f1f5f9;
}

.van-tabbar.crystal-tabbar {
  border-top: 1px solid #f1f5f9;
  background: #ffffff;
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.04);
}

.crystal-tabbar .van-tabbar-item--active {
  color: #2dd4bf !important;
}

.crystal-tabbar .van-tabbar-item__icon {
  font-size: 22px;
}

.crystal-tabbar .van-tabbar-item__text {
  font-size: 11px;
  font-weight: 500;
}
</style>

<style scoped>
.group-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
  position: relative;
  overflow: hidden;
}

.bg-shapes {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
}

.shape-1 {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(45, 212, 191, 0.1) 0%, transparent 70%);
  top: -100px;
  right: -60px;
  animation: shapeDrift 20s ease-in-out infinite alternate;
}

.shape-2 {
  width: 260px;
  height: 260px;
  background: radial-gradient(circle, rgba(251, 113, 133, 0.06) 0%, transparent 70%);
  bottom: 100px;
  left: -80px;
  animation: shapeDrift 18s ease-in-out infinite alternate-reverse;
}

.shape-3 {
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(167, 139, 250, 0.05) 0%, transparent 70%);
  top: 40%;
  left: -40px;
  animation: shapeDrift 22s ease-in-out infinite alternate;
}

.shape-4 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(251, 191, 36, 0.04) 0%, transparent 70%);
  bottom: 30%;
  right: -50px;
  animation: shapeDrift 16s ease-in-out infinite alternate-reverse;
}

@keyframes shapeDrift {
  0% {
    transform: translate(0, 0) scale(1);
  }

  100% {
    transform: translate(30px, -20px) scale(1.1);
  }
}

.group-page-index {
  position: relative;
  z-index: 1;
  background: transparent !important;
  padding-bottom: 110px;
  min-height: 100vh;
  min-height: 100dvh;
  animation: pageEnter 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes pageEnter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.page-header {
  padding: 12px 16px 8px;
}

.header-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-icon-sm {
  display: block;
  flex-shrink: 0;
}

.page-title {
  font-weight: 700;
  font-size: 18px;
  color: #1e293b;
  margin: 0;
  letter-spacing: 0.3px;
}

.group-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 16px 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
  animation: cardSlide 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.group-card:active {
  transform: scale(0.98);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.04);
}

@keyframes cardSlide {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.group-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
}

.group-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2dd4bf;
  flex-shrink: 0;
}

.group-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  flex: 1;
}

.group-count {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
  flex-shrink: 0;
}

.group-sub-list {
  border-top: 1px solid #f1f5f9;
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.group-sub-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 4px 8px 6px;
  border-radius: 10px;
  transition: background 0.15s;
}

.group-sub-item:active {
  background: #f8fafc;
}

.sub-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #cbd5e1;
  flex-shrink: 0;
}

.sub-name {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  flex: 1;
}

.sub-count {
  font-size: 12px;
  color: #94a3b8;
}

.group-empty {
  border-top: 1px solid #f1f5f9;
  padding-top: 12px;
  font-size: 13px;
  color: #cbd5e1;
  text-align: center;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-state svg {
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

.bottom-action {
  padding: 8px 16px 0;
}

.submit-btn {
  display: block;
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%);
  box-shadow: 0 4px 16px rgba(45, 212, 191, 0.3);
  transition: transform 0.2s, box-shadow 0.2s;
  font-family: inherit;
}

.submit-btn:active {
  transform: scale(0.97);
  box-shadow: 0 2px 8px rgba(45, 212, 191, 0.25);
}

.dialog-body {
  padding: 8px 20px 20px;
}

.dialog-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 6px;
  padding-left: 2px;
}

.dialog-input-wrap :deep(.van-cell) {
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 14px;
  min-height: 44px;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
}

.dialog-input-wrap :deep(.van-cell:focus-within) {
  border-color: #2dd4bf;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(45, 212, 191, 0.08);
}

.dialog-input-wrap :deep(.van-field__body) {
  background: transparent;
}

.dialog-field {
  color: #1e293b !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  background: transparent !important;
}

.dialog-input-wrap :deep(.van-field__placeholder) {
  color: #cbd5e1 !important;
  font-weight: 400 !important;
}
</style>